export { default } from "./InlineImage";
